import { render } from "./SearchTeamsForm.vue?vue&type=template&id=665e70ee"
import script from "./SearchTeamsForm.vue?vue&type=script&lang=js"
export * from "./SearchTeamsForm.vue?vue&type=script&lang=js"

import "./SearchTeamsForm.vue?vue&type=style&index=0&id=665e70ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__